import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { breakpoints } from '../../constants/styles';

const StyledRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box; 
  width: 100%;

  ${breakpoints.tabletLandscape} {
    flex-direction: row-reverse;
    justify-content: space-around;
    align-self: center;
  }

  ${({ styles }) => styles}
`;

const Row = ({ children, styles, className }) => (
  <StyledRow styles={styles} className={className}>
    {children}
  </StyledRow>
);

Row.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
  styles: PropTypes.array,
  className: PropTypes.string,
};

Row.defaultProps = {
  styles: [],
  className: '',
};

export default Row;
